import { useCertificateSummaryQuery } from "../api/queries/certificate-reporting/new-certificates/use-certificate-summary";

export function useCertificateSummaryReport(StudentIds: string[], StartDate: string, EndDate: string) {
    
    const mutation = useCertificateSummaryQuery(StudentIds, StartDate, EndDate);

    return {mutation, mutate: () => mutation.mutate({StudentIds, StartDate, EndDate})};
}
